<template>
  <div class="setting-account-account">
    <h2>授权流程</h2>

    <div class="ivu-mt ivu-pl ivu-pr">
      <Divider orientation="left">1、生成授权码</Divider>
      <Alert>进入【卡密管理】新增授权码 <br>
        为防止恶意生成占用资源，一次最多生成20个
      </Alert>
      <Divider orientation="left">2、授权域名</Divider>
      <Alert>将授权码卖给你的客户后，你的客户携带授权码自行前往 auth.h234.cn 进行绑定手机并授权 <br>
      注：授权后的APPID，更换授权时会用到，忘记可前往【项目管理】查询
      </Alert>
      <Divider orientation="left">3、程序安装教程</Divider>
      <Alert>Geek-Shop v2 安装教程文档 <a href="https://www.kancloud.cn/osuu234/geek-shop/2278960">https://www.kancloud.cn/osuu234/geek-shop/2278960</a></Alert>



    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {


      };
    },

  };
</script>
<style lang="less">
  .text {
    font-size: 15px;
    margin-bottom: 20px;
    letter-spacing: 2px;
  }
</style>